import { ElementRef, Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { loadScriptSrc } from '../../landing/landing-utils';
import { ConfigProfile } from '../enums/config-profile.enum';
import { AppConfigService } from './app-config.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root',
})
export class TurnstileService {
  private readonly appConfigService = inject(AppConfigService);
  private readonly messageService = inject(MessageService);

  initializeTurnstileScriptAndWidget(
    elementRef: ElementRef,
    unsubscribe$: Subject<void>,
  ): Promise<{ turnstileWidgetId: string; turnstileToken: string | null }> {
    return new Promise((resolve) => {
      loadScriptSrc('https://challenges.cloudflare.com/turnstile/v0/api.js', elementRef)
        .pipe(takeUntil(unsubscribe$))
        .subscribe((loaded) => {
          if (loaded) {
            this.initializeTurnstile().then(({ turnstileWidgetId, turnstileToken }) => {
              resolve({ turnstileWidgetId, turnstileToken });
            });
          } else {
            this.messageService.error('Captcha could not be loaded.');
          }
        });
    });
  }

  private initializeTurnstile(): Promise<{
    turnstileWidgetId: string;
    turnstileToken: string | null;
  }> {
    return new Promise((resolve) => {
      const turnstileContainer = document.getElementById('turnstile-container') as HTMLElement | null;

      if (turnstileContainer && window.turnstile) {
        const turnstileWidgetId = window.turnstile.render(turnstileContainer, {
          sitekey:
            this.appConfigService.config.profile === ConfigProfile.PROD
              ? '0x4AAAAAABASTqTxyzm2X-26'
              : '0x4AAAAAAA_zQUKzuD5JizID',
          theme: 'light',
          size: 'flexible',
          callback: (token: string) => {
            resolve({ turnstileWidgetId, turnstileToken: token });
          },
        });
      }
    });
  }
}
